import React from 'react';
import ReactDOM from 'react-dom';

var varStyle =
{
  //display:'inline-block',
}

var tableStyle =
{
  //display:'inline-block',
  textAlign: 'left',
  borderSpacing: 10,

}

var outerFormStyle =
{
  backgroundColor: '#FFFFFF',
  padding:10,
  maxHeight:"95vh",
  minHeight:"33vh",
  minWidth:"33vh",
  overflow:"scroll",
}

class UpdateDataForm extends React.Component {
   constructor(props)
   {
      super(props);
      this.state = {
        data: this.props.data
      }
      //console.log("Update Form Constructed");
      this.dataChanged = function(key, val)
      {
        console.log("Update Form Changed - key: " + key +" val: " + val);
        var newData = Object.assign({}, this.state.data);
        newData[key] = val;
        this.setState({'data':newData});
      }.bind(this);
   }

   componentDidMount()
   {
     
   }
   render()
   {

     var clickedSave = function()
     {
      this.props.saveCallback(this.state.data);
     }.bind(this);

     var clickedCancel = function()
     {
        this.props.saveCallback(null);
     }.bind(this);

    var valueVars = [];

    for(var v in this.state.data)
    {
      //if(typeof this.state.data[v] !== 'object')
        valueVars.push(v);
    }
    //console.log("Rendering Update data form value vars and data: ", valueVars, this.state.data);
    
      return (
        <div style={outerFormStyle}>
          <h1>{this.props.heading}</h1>
          <table style={tableStyle}>
            <tbody>
              {valueVars.map((v, i) => <FieldAndValue key={i}
                fieldName={v} fieldValue={this.state.data[v]}
                drawFunc = {this.props.drawFuncs ? this.props.drawFuncs[v] : null}
                drawFuncObj = {this.props.drawFuncObjects ? this.props.drawFuncObjects[v] : null}
                onDataChanged={this.dataChanged}/>)}
            </tbody>
          </table>
          <div>
            <button style={{float:'left'}} onClick={clickedSave}>save</button>
            <button style={{float:'right'}} onClick={clickedCancel}>cancel</button>
            <div style={{clear:'both'}}></div>
            {this.props.errorMsg ? <span><h2>Error: </h2>{this.props.errorMsg}</span>  : null}

          </div>
        </div>
      );

    }
}

class FieldAndValue extends React.Component
{
  constructor(props)
  {
    super(props);
    //console.log("FieldandValue props on CONSTRUCT: ", this.props);
    //this.state = { fieldValue: this.props.fieldValue};
  }
  render()
  {

     
  var onChangedEvent = function(e)
  {
    //this.setState({ fieldValue: e.target.value});
    this.props.onDataChanged(this.props.fieldName, e.target.value);
    
  }.bind(this);

  var onChanged = function(newVal)
  {
    //this.setState({ fieldValue: e.target.value});
    //console.log("Changing: " + this.props.fieldName + " to: " + newVal);
    this.props.onDataChanged(this.props.fieldName, newVal);
    
  }.bind(this);

      var DrawFunc = this.props.drawFunc;
      //console.log("FieldandValue props on RENDER: ", this.props);
   
      return(
        <tr>
          <td style={varStyle}>{this.props.fieldName}: </td>
          <td>
          {this.props.drawFunc ?
            <DrawFunc value={this.props.fieldValue} {...this.props.drawFuncObj} onChange={onChanged}/> :
            <input type="text" name={this.props.fieldName} onChange={onChangedEvent} value={this.props.fieldValue}/> }
          </td>
      </tr>);
    }
}

export default UpdateDataForm ;


// WEBPACK FOOTER //
// ./js/UpdateDataForm.jsx